<template>
  <div class="freight-route-rules">
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:platformManagerRate="{ row }">{{ row.platformManagerRate }}%</template>
        <template v-slot:platformOrderCommissionRate="{ row }">{{ row.platformOrderCommissionRate }}%</template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click="handleEdit(row)">修改</span>
        </template>
      </custom-table>
    </div>
    <fwsglfblConfigEdit ref="fwsglfblConfigEdit"></fwsglfblConfigEdit>
  </div>
</template>
<script>
import CustomTable from "@/components/CustomTable.vue";
import {getSupplierConfigPage} from "../api";
import tableMixin from "@/mixin/tableMixin";
import fwsglfblConfigEdit from "./fwsglfblConfigEdit.vue";
import { getLocalLabel } from "@/utils/localDict";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    fwsglfblConfigEdit,
    CustomTable,
  },
  data() {
    return {
      getTableMethod: getSupplierConfigPage,
      searchForm: {},
      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "服务商名称",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "负责人姓名",
          prop: "dutyName",
          align: "left",
          show: true,
        },
        {
          label: "负责人联系方式",
          prop: "dutyPhone",
          align: "left",
          show: true,
        },
        {
          label: "平台管理费比例（适用于第三方订单）",
          prop: "platformManagerRate",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "平台订单抽成比例",
          prop: "platformOrderCommissionRate",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "150px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    getLocalLabel,
    handleEdit(row) {
      this.$refs.fwsglfblConfigEdit.init(row)
    },
    handleAddOrEditSuccess() {
      this.getTableData()
    },
    openDetail(row) {
      this.$refs.detail.init(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.freight-route-rules {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .custom-tip {
    font-size: 0.16rem;
    padding: 0.16rem 0.2rem;
    background: rgba(18, 105, 255, 0.05);
    box-sizing: border-box;
    margin: 0 0.16rem;
    border-radius: 0.03rem;
    border: 0.01rem dashed #1269ff;
    display: flex;
    align-items: center;
    .tip-img {
      width: 0.44rem;
      height: 0.44rem;
      flex-shrink: 0;
      margin-right: 0.2rem;
    }
    .tip-title {
      display: flex;
      align-items: center;
      padding-bottom: 0.06rem;
      i {
        color: #cf9236;
        margin-right: 0.03rem;
      }
      span {
        color: #000000;
        font-size: 0.14rem;
      }
    }
    .tip-list {
      line-height: 0.26rem;
      box-sizing: border-box;
      font-size: 0.12rem;
      color: #434343;
    }
  }
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
  .statistics-box {
    display: flex;
    justify-content: space-around;
    padding: 0 0.16rem;
    margin: 0 -0.1rem;
    .statistics-list {
      width: 33.33%;
      height: 1.2rem;
      background-color: #ffffff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.2rem;
      box-sizing: border-box;
      margin: 0 0.1rem;
      .statistics-image {
        width: 0.8rem;
        height: 0.61rem;
      }
      .statistics-num {
        .num {
          font-size: 0.24rem;
          color: #000000;
          font-weight: bold;
          text-align: center;
        }

        .txt {
          font-size: 0.14rem;
          color: #434343;
          padding-top: 0.1rem;
          text-align: center;
        }
      }
    }
  }
}
</style>
